"use client";

import { c as _c } from "react/compiler-runtime";
import { useElementDimensions } from "@/hooks/use-element-dimensions";
import { motion, useMotionValue, useTransform } from "motion/react";
import { useRef } from "react";
type HeadingProps = {
  children: React.ReactNode;
};
function Heading(t0) {
  const $ = _c(23);
  const {
    children
  } = t0;
  const ref = useRef(null);
  const [t1, measure] = useElementDimensions(ref);
  const {
    width,
    height,
    top,
    left
  } = t1;
  const gradientX = useMotionValue(0.5);
  const gradientY = useMotionValue(0.5);
  let t2;
  if ($[0] !== gradientX || $[1] !== gradientY || $[2] !== left || $[3] !== top) {
    t2 = () => `conic-gradient(from 0deg at calc(${gradientX.get() * 100}% - ${left}px) calc(${gradientY.get() * 100}% - ${top}px),
                var(--primary),
                var(--foreground),
                var(--muted-foreground),
                var(--chart-4),
                var(--chart-5)
            )`;
    $[0] = gradientX;
    $[1] = gradientY;
    $[2] = left;
    $[3] = top;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const background = useTransform(t2);
  let t3;
  let t4;
  if ($[5] !== gradientX || $[6] !== gradientY || $[7] !== height || $[8] !== width) {
    t3 = e => {
      gradientX.set(e.touches[0].clientX / width);
      gradientY.set(e.touches[0].clientY / height);
    };
    t4 = e_0 => {
      gradientX.set(e_0.clientX / width);
      gradientY.set(e_0.clientY / height);
    };
    $[5] = gradientX;
    $[6] = gradientY;
    $[7] = height;
    $[8] = width;
    $[9] = t3;
    $[10] = t4;
  } else {
    t3 = $[9];
    t4 = $[10];
  }
  let t5;
  if ($[11] !== background) {
    t5 = {
      backgroundImage: background,
      cursor: "none"
    };
    $[11] = background;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== measure) {
    t6 = () => measure();
    $[13] = measure;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== children || $[16] !== t5 || $[17] !== t6) {
    t7 = <motion.h1 ref={ref} className="bg-clip-text p-16 text-center font-mono text-6xl leading-relaxed text-transparent" style={t5} onPointerEnter={t6}>{children}</motion.h1>;
    $[15] = children;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t3 || $[20] !== t4 || $[21] !== t7) {
    t8 = <div className="flex items-center justify-center" onTouchMove={t3} onPointerMove={t4}>{t7}</div>;
    $[19] = t3;
    $[20] = t4;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
}
export { Heading };